import Chart from 'chart.js/auto';

export default function () {
  const canvasList = document.querySelectorAll('.js-views-chart');

  if (!canvasList.length) return;

  for (let i = 0; i < canvasList.length; i++) {
    const canvas = canvasList[i];

    const datasets = canvas.getAttribute('data-datasets');
    const labels = canvas.getAttribute('data-labels');

    if (!datasets || !labels) return;

    new Chart(canvas, {
      type: 'line',
      data: {
        labels: JSON.parse(labels),
        datasets: JSON.parse(datasets)
      },
      options: {
        maintainAspectRatio: false
      }
    });
  }
}
